import React, { useState, useEffect } from "react";
import { PageLayout } from "../components/page-layout";
import GiftFormAdmin from "../components/forms/form-admin-gifts";

export const GiftAdminPage = () => {

    return (
        <PageLayout>
            {<GiftFormAdmin/> }
        </PageLayout>
    )
} 